module.exports = __webpack_public_path__ + "static/media/launch.be4d7fb7.svg";